import React, { useState, useEffect } from "react";
import HomeHeader from "./HomeHeader";
import About from "./About";
import HomeSlide from "./HomeSlide";
import AdmissionSession from "./AdmissionSession";
import Card from "./Card";
import DivisionPage from "./DivisionPage";
import Footer from "./Footer";
import api from "../api/api";
import TotalStudentAndApplySection from "./TotalStudentAndApplySection";

import daddy from "./images/maleeee.jpg";
import mamaaaa from "./images/femaleeee.jpg";
import sati from "./images/maleeee.jpg";
import StaffPage from "./StaffPage";

import "./Styles/home.css";

const Home = () => {


  return (
    <div>
      <div className="headerderty">
        <HomeHeader />
      </div>

 


      <div className="homeeeSlide">
        <About />
      </div>

      <div>
       <StaffPage />
      </div>



      <Footer />
    </div>
  );
};

export default Home;
